<app-status-message icon="cloud_off" title="404_NOT_FOUND" description="{{'404_NOT_FOUND_DESCRIPTION' | translate}}"
    [size]="300" color="orange" class="flex justify-center items-center mt-44">
</app-status-message>